import React from 'react';
import { OptionProps } from 'react-select';
import classNames from 'classnames';

import { CheckboxRadioInput } from '../../checkbox-radio-input';
import { Option as OptionModel } from '../option.model';

type Props = { isMultiple?: boolean } & OptionProps<OptionModel, true>;

export const Option = ({
  children,
  data,
  isFocused,
  isSelected,
  innerRef,
  innerProps,
  isMultiple,
}: Props) => (
  <div
    className={classNames(
      'flex items-center w-full select-none px-3 py-2 space-x-3',
      {
        'bg-gray-100': isFocused,
      }
    )}
    ref={innerRef}
    {...innerProps}
  >
    <CheckboxRadioInput
      type={isMultiple ? 'checkbox' : 'radio'}
      checked={isSelected}
      readOnly
      className="flex-none"
    />
    <div>
      <div className="text-gray-900">{children}</div>
      {data.helpText && <div className="text-sm">{data.helpText}</div>}
    </div>
  </div>
);
